// Owner request 2026-08-15: every non-production build (local dev, staging
// beta) carries a permanent banner so nobody can mistake the environment for
// the live platform — and so the two facts that matter in a MOCKED beta are
// on screen at all times: the money is simulated, and the data is
// disposable. Driven by the REACT_APP_ENV build arg (Vite bakes it at build
// time; the staging pipeline passes `staging`, docker-compose defaults to
// `development`, and the production image build passes `production`, which
// renders nothing). Deliberately NOT dismissible: a beta tester who has
// dismissed the notice is exactly the tester who later asks where their
// money went.
//
// The env is a prop with a baked default so tests can exercise both states
// without stubbing import.meta.env.

// "BETA", not "CLOSED BETA": signup is open (owner decision 2026-08-16 —
// signup-access-code is empty on staging).
//
// The fan-content sentence covers the seeded demo rosters, which portray
// video-game characters (see server/src/services/seed_service.rs). It lives
// in the always-visible banner so every screenshot of the beta carries the
// attribution; DemoContentNotice repeats it on the certificate surfaces.
const BANNER_TEXT =
  "BETA — NOT THE LIVE PLATFORM. All money here is simulated and has no value. Data may be reset without notice. " +
  "Demo rosters portray video-game characters — unofficial fan content, © their respective publishers.";

export function BetaBanner({
  env = import.meta.env.REACT_APP_ENV as string | undefined,
}: {
  env?: string;
}) {
  if (env === "production") return null;
  return (
    <div
      role="status"
      aria-label="Beta environment notice"
      data-testid="beta-banner"
      className="sticky top-0 z-[100] w-full bg-amber-400 px-3 py-1 text-center text-xs font-semibold uppercase tracking-wide text-amber-950"
    >
      {BANNER_TEXT}
    </div>
  );
}
